// import { useState } from "react";
import { Box } from "@chakra-ui/react";
import Button from "components/Button";
import { useForm } from "react-hook-form";
import PrimaryButton from "components/Button/PrimaryButton";

import { Modal } from "antd";
import { PessoaContato } from "features/unidades/typings/unidade";
import { TipoContatoEnum } from "features/auth/typings/user";
 import FormAddContato from "components/Features/Unidades/components/FormAddContato";

interface ModalAddContatoProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => any;
  onSaved: (data: PessoaContato) => any;
  hideCobranca?: boolean;
  defaultData?: Partial<PessoaContato>;
}

function ModalAddContato({
  isOpen,
  onClose,
  onSaved,
  isLoading,
  hideCobranca,
  defaultData,
}: ModalAddContatoProps) {
  const { control, watch, handleSubmit, setValue } = useForm<PessoaContato>({
    reValidateMode: "onChange",
    mode: "onTouched",
    defaultValues: {
      tipoContatoId: TipoContatoEnum.Celular,
      ...defaultData,
    },
  });

  const form = watch();

  const onSubmit = async (data: PessoaContato) => {
    if (
      data.tipoContatoId === TipoContatoEnum.Telefone ||
      data.tipoContatoId === TipoContatoEnum.Celular
    ) {
      data.conteudo = data.conteudo.replace(/\D/g, "");
      data.receberCobranca = false;
    }
    onSaved(data);
  };

  return (
    <Modal
      visible={isOpen}
      title="Contato"
      footer={
        <Box
          display="flex"
          gridGap={4}
          justifyContent="flex-end"
          flex={1}
          mt={8}
          mb={4}
        >
          <Button isDisabled={isLoading} onClick={onClose}>
            Cancelar
          </Button>

          <PrimaryButton
            isDisabled={isLoading}
            isLoading={isLoading}
            onClick={() => handleSubmit(onSubmit)()}
          >
            Salvar
          </PrimaryButton>
        </Box>
      }
      onCancel={onClose}
      width="781px"
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <FormAddContato
          hideCobranca={hideCobranca}
          control={control}
          form={form}
          setValue={setValue}
        />
      </form>
    </Modal>
  );
}

export default ModalAddContato;
